import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-change-password-instruction-view',
  templateUrl: './change-password-instruction-view.component.html',
  styleUrls: ['./change-password-instruction-view.component.css'],
})
export class ChangePasswordInstructionViewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
